export default __webpack_public_path__ + "static/2023_2024_WVS INDIA FOREIGN CONTRIBUTION ACCOUNTS-30a9166bfa823a15eb1eaad97df5b012.pdf";